// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","682":"component---src-pages-about-js","989":"component---src-templates-blog-post-js"}[chunkId] + "-" + {"351":"7c8e9f7261e08fe52240","678":"4918a2f29b5ae19108c1","682":"122584ecd3c29417e549","989":"f00ffa1f8ba563a88a30"}[chunkId] + ".js";
};